import React, { useState } from "react";
import Footer from "../../Sub/Footer";
import CommonHeader from "../../Sub/CommonHeader";
import { useNavigate } from "react-router-dom";
import { Form, Row, Col, Button } from "react-bootstrap";
import { Formik } from "formik";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import { sendOtp, sendVerificationCode, signUpWithPhone } from "../../../reducers/commonReducer";
import { verifyOtp } from "../../../const";
import GotoTop from "../../../Components/GotoTop";

const schema = yup.object().shape({
  phone:yup.string()
  .required('Phone number is required')
  .matches(/^\d{10}$/, 'Phone number must be exactly 10 digits')
  .min(10, 'Phone number must be exactly 10 digits')
  .max(10, 'Phone number must be exactly 10 digits'),
});

const RegisterWithPhone = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  return (
    <>
      <CommonHeader />
      <div className="container-fluid">
        <div className="page-main p-5 mbl-pedding-10">
          <div className="section__head d-md-flex justify-content-between mb-40">
            <div className="section__title">
              <h1>Verify With Phone</h1>
            </div>
          </div> 
          <Row>
            <Col md={4} className="m-auto">
              <Formik
                validationSchema={schema}
                onSubmit={async (values) => {
                  setLoading(true)
                  const apiResp = await dispatch(sendOtp(values));
                  if(apiResp?.payload?.status){
                    navigate(`${verifyOtp}?verifiUser=${apiResp?.payload?.verifiUser}`)
                    localStorage.setItem("phone", values.phone);
                    localStorage.setItem("verifiUser", apiResp?.payload?.verifiUser);
                  }
                  setLoading(false)
                }}
                initialValues={{
                  phone: "",
                }}
              >
                {({ handleSubmit, handleChange, touched, values, errors }) => (
                  <Form className="container" onSubmit={handleSubmit}>
                    <Row className="mb-3">
                      <Col md={12} sm={12}>
                        <Form.Group>
                          <Form.Label>Enter Phone</Form.Label>
                          <Form.Control
                            type="number"
                            placeholder="Enter Phone"
                            name="phone"
                            value={values.phone}
                            onChange={handleChange}
                            isInvalid={!!errors.phone}
                            className={
                              errors.phone && touched.phone && "errors"
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.phone}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md={12} sm={12}>
                        <Button
                          variant="success"
                          className="bg-thememain w-100"
                          type="submit"
                          disabled = {loading ? true : false}
                        >
                          Send Verification Code
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                )}
              </Formik>
            </Col>
          </Row>
        </div>
      </div>
      <GotoTop />
      <Footer />
    </>
  );
};

export default RegisterWithPhone;
